module.exports = __webpack_public_path__ + "img/r-239.5c253b90.jpg";